import { render, staticRenderFns } from "./ActivitySummary.vue?vue&type=template&id=576ff1dc&scoped=true"
import script from "./ActivitySummary.vue?vue&type=script&lang=js"
export * from "./ActivitySummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ff1dc",
  null
  
)

export default component.exports